import { useCallback } from "react";
import { useSelector } from "react-redux";

export function useDirectoryFilter(eventId, directoryId) {
    const selector = useCallback((state) => state.events[eventId]?.directoryFilter[directoryId], [eventId, directoryId]);
    return useSelector(selector) ?? '';
}
